module.exports = __webpack_public_path__ + "media/assets/icons/closeCircle-5e4210e95fd5e7d1191d68566ace2123.svg";